
































import Vue from "vue"

export default Vue.extend({
  auth: false,
  layout: "firstbit",
  head: {
    title: 'Личный кабинет абитуриента'
  },
  name: "hello",
  async asyncData({app, redirect, route}) {
    if (app) {
      app.store!.dispatch('needHelp/setLink', 'auth');
    }

  },
  created() {
    this.$store.dispatch('needHelp/setLink', 'auth');
  },
  mounted() {
    if (this.isLogout) {
        this.logout()
    }
  },
  beforeDestroy() {
    this.$store.dispatch('needHelp/setLink', false);
  },
  computed: {
    needHelp() {
      return this.$store.getters['needHelp/get'];
    },
    isLogout() {
      return this.$store.state.logout.isLogout;
    }
  },
  methods: {
    async logout() {
      let tempLink = '/'

      try {
        const result = await this.$api('auth', {}, 'DELETE')
        tempLink = result.data.url
        this.$store.commit('logout/setLogout', false)
      } catch (e) {
        console.error('e', e)
      }

      // this.$store.dispatch('application/deleteDataFromLocalStorage');


      this.$auth.$storage.setState('user', false);
      (this.$auth.strategies.local as any).token.reset();
      (this.$auth.strategies.local as any).requestHandler.reset()
      window.location.href = tempLink
    }
  },
})
